import React from "react";
import paymentStatusLogo from "../../assets/images/Payment unsuccessful.png";
import { ReactComponent as QParkLogo } from "../../assets/images/Q-Park - Quality in parking.svg";
import { FormattedMessage } from "react-intl";

const PaymentFailed: React.FC = () => {
  return (
    <React.Fragment>
      <div className="main">        
        <div className="content">
          <img src={paymentStatusLogo} alt="Payment failed" className="status-failed" />
          <p className="App-status">
            <FormattedMessage id="failedStatus" />
          </p>
          <p className="App-status-info">
            <FormattedMessage id="failedStatusInfo" />
          </p>
        </div>
      </div>
      <div className="footer">
        <QParkLogo />
      </div>
    </React.Fragment>
  );
};

export default PaymentFailed;
